module.exports = __webpack_public_path__ + "media/images/icon-search-130d031d78fb1bfe06bae6c2bbb7f960.svg";